module.exports = {
  footerText: 'Copyright Harga Kurs © 2019',
}
